import React, { useEffect, useState } from "react";
import { Card, Row, Col, Typography } from "antd";
import { Link } from "react-router-dom";

const { Title } = Typography;

export default function ByArtists() {
  const [artists, setArtists] = useState([]);

  useEffect(() => {
    fetch("https://simolmedia.tw1.ru/api/get_artists_full.php")
      .then(r => r.json())
      .then(d => setArtists(d.artists || []));
  }, []);

  return (
    <div style={{ padding: 20 }}>
      <Title level={3}>Выберите артиста</Title>

      <Row gutter={[16, 16]}>
        {artists.map(a => (
          <Col xs={12} sm={8} md={6} lg={4} key={a.id}>
            {/* путь остаётся внутри /downloads */}
            <Link to={`/downloads/artist/${a.id}`} state={{ artistName: a.name }}>
              <Card
                hoverable
                cover={
                  <img
                    alt={a.name}
                    src={
                      a.thumbnail ||
                      "https://audiobuzz-web.tmweb.ru/uploads/thumbnails/default_cover.jpg"
                    }
                    style={{ width: "100%", height: 180, objectFit: "cover" }}
                  />
                }
              >
                <Card.Meta title={a.name} description="Артист" />
              </Card>
            </Link>
          </Col>
        ))}
      </Row>
    </div>
  );
}
